import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { analyticsService } from "./analytic.service";

export const fetchDashboardData = createAsyncThunk(
  "analytics/fetchDashboardData",
  async (params, thunkAPI) => {
    try {
      return await analyticsService.getDashboardData(params);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to fetch dashboard data";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchSalesData = createAsyncThunk(
  "analytics/fetchSalesData",
  async ({ startDate, endDate }, thunkAPI) => {
    try {
      return await analyticsService.getSalesData(startDate, endDate);
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to fetch sales data";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const fetchInventoryData = createAsyncThunk(
  "analytics/fetchInventoryData",
  async (_, thunkAPI) => {
    try {
      return await analyticsService.getInventoryData();
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to fetch inventory data";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  dashboardData: null,
  salesData: null,
  inventoryData: null,
  isLoading: false,
  error: null,
};

export const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchDashboardData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardData = action.payload.data;
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchSalesData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSalesData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.salesData = action.payload.data;
      })
      .addCase(fetchSalesData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchInventoryData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchInventoryData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.inventoryData = action.payload.data;
      })
      .addCase(fetchInventoryData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default analyticsSlice.reducer;
